import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_up",
  "use": "icon-arrow_up-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol viewBox=\"0 0 19 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow_up\"><g id=\"icon-arrow_up_ç®­å¤´ä¸\"><path id=\"icon-arrow_up_Line Copy 15\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.4375 11.1789L5.22646 11.9824L9.5 7.62974L13.7735 11.9824L14.5625 11.1789L9.5 6.01853L4.4375 11.1789Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol